
import { TypedVue } from "@/store/types";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class InsightEditBox extends TypedVue {
  @Prop({ required: true })
  readonly title!: string;

  @Prop({ required: true })
  readonly prompt!: string;

  @Prop({ default: "" })
  readonly placeholder!: string;

  @Prop({ default: "" })
  readonly value!: string;

  @Prop({ default: false })
  readonly canEdit!: boolean;

  @Prop({ required: true })
  readonly onSave!: (value: string) => Promise<void>;

  // Opens straight into edit mode (e.g. from the report's "+ Add notes" link).
  @Prop({ default: false })
  readonly startEditing!: boolean;

  public editing = false;
  public draft = "";
  public saving = false;
  public error = false;

  mounted(): void {
    if (this.startEditing && this.canEdit) {
      this.startEdit();
    }
  }

  startEdit(): void {
    this.draft = this.value;
    this.editing = true;
    this.error = false;
  }

  cancel(): void {
    this.editing = false;
    this.error = false;
    this.$emit("cancel");
  }

  async save(): Promise<void> {
    this.saving = true;
    this.error = false;
    try {
      await this.onSave(this.draft);
      this.editing = false;
      this.$emit("saved");
    } catch {
      this.error = true;
    } finally {
      this.saving = false;
    }
  }
}
